import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";

export const parseZips = (s) => [...new Set(String(s).split(/[\s,;]+/).filter(Boolean))];

export default function CreateWaveDialog({ open, onOpenChange, onCreated }) {
  const [f, setF] = useState({ name: "", target_size: "50", zips: "", max_gender_pct: "60" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const zips = parseZips(f.zips);
  const bad = zips.filter((z) => !/^\d{5}$/.test(z));
  const valid = f.name.trim() && +f.target_size >= 1 && zips.length && !bad.length && +f.max_gender_pct >= 1 && +f.max_gender_pct <= 100;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await api("/admin/waves", { body: { name: f.name.trim(), target_size: +f.target_size, zips, max_gender_pct: +f.max_gender_pct } });
      onCreated(res.wave);
      onOpenChange(false);
      setF({ name: "", target_size: "50", zips: "", max_gender_pct: "60" });
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[20px]" data-testid="wave-create-dialog">
        <form onSubmit={submit} className="space-y-4">
          <DialogHeader><DialogTitle>New wave</DialogTitle>
            <DialogDescription>We pick people from the waitlist in these ZIPs, oldest first, keeping any one gender at or under the max share. You review before anything is sent.</DialogDescription></DialogHeader>
          <div><Label htmlFor="wv-name">Name</Label><Input id="wv-name" value={f.name} onChange={set("name")} placeholder="Milwaukee wave 1" className="mt-2" data-testid="wave-name-input" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><Label htmlFor="wv-size">Target size</Label><Input id="wv-size" inputMode="numeric" value={f.target_size} onChange={(e) => setF((s) => ({ ...s, target_size: e.target.value.replace(/\D/g, "") }))} className="mt-2" data-testid="wave-target-input" /></div>
            <div><Label htmlFor="wv-pct">Max gender share (%)</Label><Input id="wv-pct" inputMode="numeric" value={f.max_gender_pct} onChange={(e) => setF((s) => ({ ...s, max_gender_pct: e.target.value.replace(/\D/g, "") }))} className="mt-2" data-testid="wave-pct-input" /></div>
          </div>
          <div><Label htmlFor="wv-zips">ZIPs</Label><Textarea id="wv-zips" rows={3} value={f.zips} onChange={set("zips")} placeholder="53202, 53203" className="mt-2 font-mono text-sm" data-testid="wave-zips-input" />
            <p className={`mt-1 text-xs ${bad.length ? "cw-error" : "cw-muted"}`}>{bad.length ? `Not 5-digit ZIPs: ${bad.slice(0, 5).join(", ")}` : `${zips.length} ZIP${zips.length === 1 ? "" : "s"}`}</p></div>
          {error && <p className="cw-error text-sm" role="alert" data-testid="wave-create-error">{error}</p>}
          <DialogFooter><Button type="submit" disabled={!valid || busy} data-testid="wave-create-submit-button">{busy ? "Picking…" : "Create and auto-pick"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
